import { getList } from 'firekit'

export default function getClient(state) {
  const {
    client: { uid },
    auth: { uid: authUid },
  } = state
  const clients = getList(state, `user_clients/${authUid}`)

  const client = clients.find((c) => c.key === uid)
  const { key = null, val = null } = client ? client : {}

  return { uid: key, ...val }
}
